// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Skeleton, Table } from '@/ui';
import { Pagination } from '@/components';
import { StyledWrapper } from '../CategoryNameSwitch/CategoryNameSwitchStyles';
import FilterValuesFiltersContainer from '../../containers/FilterValuesFiltersContainer/FilterValuesFiltersContainer';

// Models
import { IFilterValue } from '@/models/filters.model';

// Helpers
import { getFilterValuesTableColumns } from './columns';

type TFilterValuesList = {
  filterValuesList: IFilterValue[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  canManage: boolean;
  onFilterValueDelete: (filterValue: IFilterValue) => void;
  onFilterValueEdit: (filterValue: IFilterValue) => void;
  onPageChange: (page: number) => void;
};

const FilterValuesList = ({
  isLoading,
  filterValuesList,
  total,
  currentPage,
  canManage,
  onPageChange,
  onFilterValueDelete,
  onFilterValueEdit,
}: TFilterValuesList) => {
  const { t } = useTranslation(['categories']);

  if (isLoading) return <Skeleton />;

  return (
    <StyledWrapper>
      <Table
        columns={getFilterValuesTableColumns({ t, canManage, onFilterValueDelete, onFilterValueEdit })}
        dataSource={filterValuesList}
        components={{
          header: {
            wrapper: FilterValuesFiltersContainer,
          },
        }}
      />
      <Pagination current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default FilterValuesList;
